import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "../legal/legal.css";

function HelpCenter() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  const faqs = isNe
    ? [
    {
      q: "भाडाको सम्पत्ति कसरी खोज्ने?",
      a: "सम्पत्ति खोज्नुहोस् पेजमा जानुहोस्, सहर, मूल्य, सुत्ने कोठा र प्रकार अनुसार फिल्टर गर्नुहोस्। कुनै पनि सूची खोल्दा फोटो, पूरा विवरण र मालिकलाई सिधै सम्पर्क गर्न सक्नुहुन्छ।",
    },
    {
      q: "भाडावालका लागि GharBhada निःशुल्क हो?",
      a: "हो। सूची हेर्न र मालिकसँग सन्देश गर्न भाडावालका लागि पूर्ण रूपमा निःशुल्क छ। प्लेटफर्मबाट ब्रोकर शुल्क लाग्दैन।",
    },
    {
      q: "मेरो सम्पत्ति कसरी सूचीबद्ध गर्ने?",
      a: "सम्पत्ति मालिकको रूपमा दर्ता वा लगइन गर्नुहोस्, त्यसपछि List Your Property मा जानुहोस्। विवरण भर्नुहोस्, फोटो अपलोड गर्नुहोस्, र पठाउनुहोस्। समीक्षा पछि सूची सार्वजनिक हुन्छ।",
    },
    {
      q: "भाडा आवेदन प्रक्रिया कसरी काम गर्छ?",
      a: "मनपर्ने सम्पत्तिमा Apply क्लिक गर्नुहोस्। व्यक्तिगत विवरण, रोजगारी जानकारी, र आवश्यक कागजात अपलोड गर्नुहोस्। त्यसपछि मालिकले समीक्षा गरेर निर्णय दिन्छन्।",
    },
    {
      q: "मालिकलाई सन्देश कसरी पठाउने?",
      a: "कुनै पनि सूची खोलेर Message Owner बटन प्रयोग गर्नुहोस्। भाडावालको रूपमा लगइन हुनु आवश्यक छ। सन्देशहरू ड्यासबोर्डको Messages मा देखिन्छन्।",
    },
    {
      q: "सूची शंकास्पद लागेमा के गर्ने?",
      a: "प्लेटफर्म बाहिर पैसा नतिर्नुहोस्। support@gharbhada.org मा विवरण पठाउनुहोस्, हामी छिटो जाँच गर्छौं।",
    },
    {
      q: "पासवर्ड कसरी रिसेट गर्ने?",
      a: "Login पेजमा Forgot Password क्लिक गर्नुहोस्। तपाईंको इमेलमा रिसेट लिंक पठाइन्छ। नदेखिए स्प्याम फोल्डर जाँच गर्नुहोस्।",
    },
    {
      q: "प्रकाशित सूची पछि सम्पादन गर्न मिल्छ?",
      a: "मिल्छ। Owner Dashboard मा गएर Edit गर्नुहोस्। परिवर्तन सार्वजनिक हुनु अघि छोटो समीक्षा हुन्छ।",
    },
    {
      q: "GharBhada नेपालका कुन क्षेत्रहरूमा उपलब्ध छ?",
      a: "हाल काठमाडौं उपत्यका, पोखरा र ललितपुरमा उपलब्ध छ। थप सहरहरूमा विस्तार भइरहेको छ।",
    },
    {
      q: "सपोर्टसँग कसरी सम्पर्क गर्ने?",
      a: "support@gharbhada.org मा इमेल गर्नुहोस्। हामी सोमबारदेखि शनिबार उपलब्ध छौं।",
    },
  ]
    : [
    {
      q: "How do I find a rental property?",
      a: "Go to Browse Properties, use the search bar to filter by city, price range, bedrooms, and type. Click any listing to see photos, full details, and contact the owner directly.",
    },
    {
      q: "Is GharBhada free to use for renters?",
      a: "Yes — browsing listings and messaging owners is completely free for renters. There are no broker fees charged through the platform.",
    },
    {
      q: "How do I list my property?",
      a: "Sign up or log in as a property owner, then go to List Your Property. Fill in the details, upload photos, and submit. Our team reviews listings before they go live.",
    },
    {
      q: "How does the rental application work?",
      a: "Once you find a property you like, click Apply. You'll fill in personal details, employment info, and upload required documents. The owner will review and get back to you.",
    },
    {
      q: "How do I message a property owner?",
      a: "Open any listing and use the Message Owner button. You'll need to be logged in as a renter. All messages are accessible from your dashboard under Messages.",
    },
    {
      q: "What should I do if a listing seems suspicious?",
      a: "Do not pay any money outside the platform. Contact us at support@gharbhada.org and we'll investigate promptly. Verified listings have been reviewed by our team.",
    },
    {
      q: "How do I reset my password?",
      a: "Go to the Login page and click Forgot Password. We'll send a reset link to your registered email. Check your spam folder if you don't see it within a few minutes.",
    },
    {
      q: "Can I edit my listing after publishing?",
      a: "Yes. Go to your Owner Dashboard and click Edit on any active listing. Changes go through a brief review before updating publicly.",
    },
    {
      q: "What areas of Nepal does GharBhada cover?",
      a: "Currently we cover Kathmandu Valley, Pokhara, and Lalitpur. We're expanding to more cities — if you'd like your area added, email support@gharbhada.org.",
    },
    {
      q: "How do I contact support?",
      a: "Email us at support@gharbhada.org. We're available Mon–Sat and typically respond within a few hours.",
    },
  ];

  return (
    <div className="legal-page">
      {/* Hero */}
      <div className="legal-hero">
        <div className="container">
          <button
            type="button"
            className="legal-back-btn"
            onClick={() => navigate(-1)}
          >
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1 className="fw-bold mb-2">{isNe ? "मद्दत केन्द्र" : "Help Center"}</h1>
          <p className="mb-0 opacity-75">
            {isNe
              ? "GharBhada मा भाडा र सूचीबद्ध गर्ने बारे सामान्य प्रश्नहरूको उत्तर।"
              : "Answers to common questions about renting and listing on GharBhada."}
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">

            <div className="legal-card mb-5">
              <h2 className="fw-bold mb-1" style={{ fontSize: "1.2rem" }}>
                {isNe ? "बारम्बार सोधिने प्रश्नहरू" : "Frequently Asked Questions"}
              </h2>
              <p className="text-muted small mb-4">
                {isNe ? "आवश्यक उत्तर भेटिएन?" : "Can't find what you're looking for?"}{" "}
                <a href="mailto:support@gharbhada.org" className="text-decoration-none">
                  {isNe ? "हामीलाई इमेल गर्नुहोस्" : "Email us"}
                </a>
                .
              </p>

              <div className="accordion" id="helpAccordion">
                {faqs.map((faq, i) => (
                  <div className="accordion-item border-0 border-bottom" key={i}>
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed px-0 fw-semibold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#faq-${i}`}
                        aria-expanded="false"
                        aria-controls={`faq-${i}`}
                        style={{ background: "none", boxShadow: "none", color: "#1b2f45" }}
                      >
                        {faq.q}
                      </button>
                    </h2>
                    <div id={`faq-${i}`} className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                      <div className="accordion-body px-0 text-muted">
                        {faq.a}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact CTA */}
            <div className="legal-contact-box text-center">
              <h5 className="fw-bold mb-2">{isNe ? "अझै मद्दत चाहियो?" : "Still need help?"}</h5>
              <p className="text-muted mb-3">
                {isNe
                  ? "हाम्रो नेपाल-आधारित सपोर्ट टोली सोमबारदेखि शनिबारसम्म उपलब्ध छ र भाडावाल तथा मालिक दुबैलाई सहयोग गर्छ।"
                  : "Our Nepal-based support team is available Mon–Sat and happy to assist renters and owners alike."}
              </p>
              <a
                href="mailto:support@gharbhada.org"
                className="btn btn-primary px-4"
                style={{ background: "var(--gb-primary)", borderColor: "var(--gb-primary)" }}
              >
                {isNe ? "support@gharbhada.org मा इमेल गर्नुहोस्" : "Email support@gharbhada.org"}
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;
